var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgArrow(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "100%",
    height: "100%",
    viewBox: "0 0 16 13",
    fill: "#000000",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0.416796 12.0781L0.416797 0.921875C0.416797 0.480274 0.77207 0.125001 1.21367 0.125001L2.01055 0.125001C2.45215 0.125001 2.80742 0.480274 2.80742 0.921875L2.80742 12.0781C2.80742 12.5197 2.45215 12.875 2.01055 12.875L1.21367 12.875C0.772069 12.875 0.416796 12.5197 0.416796 12.0781ZM8.86699 3.12656L11.0451 5.30469L4.40117 5.30469C3.95957 5.30469 3.6043 5.65996 3.6043 6.10156L3.6043 6.89844C3.6043 7.34004 3.95957 7.69531 4.40117 7.69531L11.0451 7.69531L8.86699 9.87344C8.55488 10.1855 8.55488 10.6902 8.86699 10.999L9.43144 11.5635C9.74355 11.8756 10.2482 11.8756 10.557 11.5635L15.0594 7.06445C15.3715 6.75234 15.3715 6.24766 15.0594 5.93887L10.5604 1.43984C10.2482 1.12774 9.74356 1.12774 9.43477 1.43984L8.87031 2.0043C8.5582 2.31309 8.5582 2.81777 8.86699 3.12656Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrow);
export default __webpack_public_path__ + "static/media/arrow.576ea26d2310c60d32d42619928f6986.svg";
export { ForwardRef as ReactComponent };